import React, { useState } from 'react';
import CIHAFilters from './Filters/CIHAFilters';
import { Modal } from '@mui/material';
import { Buttons } from './Buttons';
import UnityFilter from './UnityFilter';
import CityFilter from './CityFilter';
import PeriodIndicator from '../../Common/Filters/PeriodIndicator';
import { AvailablePeriodProvider } from '../../Common/contexts/AvailablePeriodContext';
import { useCIHAFiltersContext } from './Filters/hooks/useCIHAFiltersContext';

const CIHAChartsContainer = ({ title, className, children }) => {
    const { filters } = useCIHAFiltersContext();
    const [open, setOpen] = useState(false);
    const [isUnityFilterOpen, setIsUnityFilterOpen] = useState(false);
    const [isCidadeFilterOpen, setIsCidadeFilterOpen] = useState(false);

    return (
        <AvailablePeriodProvider>
            <div className={`${className}`}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '16px'
                    }}
                >
                    <h2 className="title-dashboards">{title}</h2>
                    <Buttons
                        onClickFilters={() => setOpen(true)}
                        onClickCityFilter={() => setIsUnityFilterOpen(true)}
                        onClickCidadeFilter={() => setIsCidadeFilterOpen(true)}
                    />
                    <Modal open={open} onClose={() => setOpen(false)}>
                        <div
                            style={{
                                position: 'absolute',
                                top: '10%',
                                left: '50%',
                                transform: 'translate(-50%, 0)',
                                backgroundColor: '#fff',
                                padding: '24px',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                                maxWidth: '90vw',
                                width: '80%'
                            }}
                        >
                            <CIHAFilters />
                        </div>
                    </Modal>
                    <Modal
                        open={isUnityFilterOpen}
                        onClose={() => setIsUnityFilterOpen(false)}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                top: '10%',
                                left: '50%',
                                transform: 'translate(-50%, 0)',
                                backgroundColor: '#fff',
                                padding: '24px',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                                maxWidth: '90vw',
                                width: '80%'
                            }}
                        >
                            <UnityFilter />
                        </div>
                    </Modal>
                    <Modal
                        open={isCidadeFilterOpen}
                        onClose={() => setIsCidadeFilterOpen(false)}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                top: '10%',
                                left: '50%',
                                transform: 'translate(-50%, 0)',
                                backgroundColor: '#fff',
                                padding: '24px',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                                maxWidth: '90vw',
                                width: '80%'
                            }}
                        >
                            <CityFilter />
                        </div>
                    </Modal>
                </div>

                <PeriodIndicator filters={filters} />

                <div className="charts-container-dashboards">{children}</div>
            </div>
        </AvailablePeriodProvider>
    );
};

export default CIHAChartsContainer;
